import { BaseResource } from "./base.resource";

export const TsdfCodeAccessLevel = {
  None: 0,
  View: 1 << 0,
  Edit: 1 << 1,
  Delete: 1 << 2,
};

export class TsdfCode extends BaseResource {
  active: boolean;
  code: string;
  description: string;
  disposalMethod: string;

  constructor(options?: any) {
    super(options);
    // Initialize properties...
  }

  get canView(): boolean {
    return (this.accessLevel & TsdfCodeAccessLevel.View) > 0;
  }
  get canEdit(): boolean {
    return (this.accessLevel & TsdfCodeAccessLevel.Edit) > 0;
  }
  get canDelete(): boolean {
    return (this.accessLevel & TsdfCodeAccessLevel.Delete) > 0;
  }
}
